module.exports = __webpack_public_path__ + "img/14_24.151f1648.png";